
import {
  computed,
  defineComponent,
  onMounted,
  onBeforeUnmount,
  reactive, ref,
} from 'vue';
import { useStore } from 'vuex';
import DistrictOfficeInterface from '@/interfaces/DistrictOfficeInterface';

export default defineComponent({
  props: {
    districtOfficeId: {
      type: String,
      required: true,
    },
  },

  setup(props) {
    const root = ref<InstanceType<typeof HTMLElement>>();
    const store = useStore();

    const districtOffice = computed<DistrictOfficeInterface>(() => store.getters['districtOffices/districtOffice'](parseInt(props.districtOfficeId, 10)));
    const consultationTime = computed<string>(() => {
      if (districtOffice.value !== null && districtOffice.value.consultationTime !== null) {
        return districtOffice.value.consultationTime.replace(/(?:\r\n|\r|\n)/g, '<br>');
      }

      return '';
    });

    const sizeClasses = reactive({ value: [] as string[] });

    const setSizeClass = () => {
      sizeClasses.value = [];

      if (root.value) {
        const elementWidth = root.value.scrollWidth;
        if (elementWidth >= 680) {
          sizeClasses.value.push('wide');
        }
      }
    };

    const classes = computed(() => {
      const cls = [...sizeClasses.value];
      if (districtOffice.value === null) {
        cls.push('loading');
      }
      return cls;
    });

    onMounted(() => {
      window.addEventListener('resize', setSizeClass);
      window.addEventListener('load', setSizeClass);
      setSizeClass();
    });

    onBeforeUnmount(() => {
      window.removeEventListener('resize', setSizeClass);
      window.removeEventListener('load', setSizeClass);
    });

    return {
      root,
      store,
      districtOffice,
      consultationTime,
      sizeClasses,
      classes,
    };
  },
});
